import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../static/icons/close.svg'
import _imports_1 from '../../static/icons/cancel_white_icon.svg'
import _imports_2 from '../../static/icons/trash_icon.svg'
import _imports_3 from '../../static/icons/filter_icon.svg'


const _hoisted_1 = { class: "review-facets" }
const _hoisted_2 = { class: "review-facets__container" }
const _hoisted_3 = { class: "review-facets__selected" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "review-facets__selected-facet" }
const _hoisted_6 = ["alt", "onClick"]
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "review-facets__remove-all-icon",
  src: _imports_2,
  role: "presentation",
  alt: ""
}, null, -1)
const _hoisted_9 = { class: "review-facets__actions" }
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "review-facets__filter-icon",
  role: "presentation",
  alt: ""
}, null, -1)

import { computed, ref, onMounted, watch } from 'vue';

import { FacetKeys, getReviewsContext } from '@/composables/useReviews';
import useWebsiteText from '@/composables/useWebsiteTexts';

import DrawerLayer from '../DrawerLayer.vue';
import ReviewFacetDrawer from './ReviewFacetDrawer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewFacets',
  setup(__props) {

const {
  selectedFacets,
  sortingMethod,
  isSortFacetSelected,
  sortOptions,
  removeFacet,
  removeFacetValues,
  clearFacets,
  facetDisplayFormatter,
} = getReviewsContext();
const { websiteText } = useWebsiteText();

const floatingAddToCartElement = ref<HTMLElement | null>(null);

const isDrawerOpen = ref(false);

const sortingMethodLabel = computed(
  () => sortOptions.value.find((s) => s.value === sortingMethod.value)?.label
);

watch(isDrawerOpen, () => {
  if (!floatingAddToCartElement.value) return;
  if (isDrawerOpen.value) {
    floatingAddToCartElement.value.style.display = 'none';
  } else {
    setTimeout(() => {
      floatingAddToCartElement.value!.style.display = 'block';
    }, 500);
    isSortFacetSelected.value = false;
  }
});

onMounted(() => {
  const element = document.getElementById('fatc-teleport-target');
  if (!element) return;
  floatingAddToCartElement.value = element;
});

function closeDrawer() {
  isDrawerOpen.value = false;
  isSortFacetSelected.value = false;
}

function openReviewSort() {
  isDrawerOpen.value = true;
  isSortFacetSelected.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedFacets), (facets, key) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (facets.length && key !== 'productRating')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["review-facets__selected-container", { 'review-facets__selected-group': facets.length > 1 }])
                  }, [
                    (facets.length > 1)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "review-facets__selected-container-icon",
                          src: _imports_0,
                          onClick: ($event: any) => (_unref(removeFacetValues)(key))
                        }, null, 8, _hoisted_4))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facets, (value) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_unref(facetDisplayFormatter)(key, value)) + " ", 1),
                        _createElementVNode("img", {
                          class: "review-facets__selected-facet-icon",
                          src: _imports_1,
                          alt: _unref(websiteText)('global__remove').value,
                          onClick: ($event: any) => (_unref(removeFacet)(key, value))
                        }, null, 8, _hoisted_6)
                      ]))
                    }), 256))
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]),
        (
          Object.keys(_unref(selectedFacets)).filter((f) => f !== 'productRating')
            .length
        )
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "review-facets__selected-reset",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(clearFacets) && _unref(clearFacets)(...args))),
              "aria-label": _unref(websiteText)('global__remove_all').value
            }, [
              _hoisted_8,
              _createElementVNode("span", null, _toDisplayString(_unref(websiteText)('review_reset').value), 1)
            ], 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "review-facets__filter",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isDrawerOpen.value = true)),
          "aria-label": _unref(websiteText)('tycka__filters').value
        }, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_unref(websiteText)('review_filter').value), 1)
        ], 8, _hoisted_10),
        _createElementVNode("button", {
          class: "review-facets__sort",
          onClick: openReviewSort
        }, _toDisplayString(_unref(websiteText)('review_sorting').value) + ": " + _toDisplayString(_unref(sortingMethodLabel)), 1)
      ])
    ]),
    _createVNode(DrawerLayer, {
      modelValue: isDrawerOpen.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isDrawerOpen).value = $event)),
      showCloseIcon: false
    }, {
      default: _withCtx(() => [
        _createVNode(ReviewFacetDrawer, {
          showBackButton: true,
          onCloseDrawer: closeDrawer
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})